import clsx from 'clsx';

import { ReactComponent as CopyIcon } from '@/assets/icons/copy.svg';

import styles from './component.module.scss';

const CopyableLinkableContent = ({
  content,
  linkTo,
  isExternal,
  value,
  className
}: {
  content: string | ((value: string) => string);
  linkTo?: string | ((value: string) => string);
  isExternal?: boolean;
  value: string;
  className?: string;
}) => {
  const doCopy = () => {
    if (!navigator.clipboard) {
      return;
    }

    navigator.clipboard.writeText(value);
  };

  const resolvedContent =
    typeof content === 'function' ? content(value) : content;

  return (
    <span className={clsx(styles.main, className)}>
      {linkTo && (
        <a
          href={
            typeof linkTo === 'function'
              ? linkTo(value)
              : typeof linkTo === 'string'
              ? linkTo
              : undefined
          }
          target={linkTo !== undefined && isExternal ? '_blank' : undefined}
        >
          {resolvedContent}
        </a>
      )}
      {!linkTo && resolvedContent}

      <CopyIcon onClick={doCopy} />
    </span>
  );
};

export { CopyableLinkableContent };
